import ScreensViewContainer from "./containers/ClientsViewContainer";

export default ScreensViewContainer;
